/* eslint-disable */

import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import controlDefaults from './controlDefaults';

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    cspNonce: (window as any).cspNonce,
  },
  defaults: controlDefaults,
  icons: {
    defaultSet: 'mdi',
  },
});

export default vuetify;
